import { render } from "./Manufacturers.vue?vue&type=template&id=438ae7b2"
import script from "./Manufacturers.vue?vue&type=script&lang=ts"
export * from "./Manufacturers.vue?vue&type=script&lang=ts"
script.render = render

export default script